/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("configdrift.camera", require("./rawicons/camera.icon.svg.js"));
IconRegistry.registerIcon("configdrift.eye", require("./rawicons/eye.icon.svg.js"));
IconRegistry.registerIcon("configdrift.system", require("./rawicons/system.icon.svg.js"));
IconRegistry.registerIcon("configdrift.thumbsup", require("./rawicons/thumbsup.icon.svg.js"));
IconRegistry.registerIcon("configdrift.view_more", require("./rawicons/view_more.icon.svg.js"));
IconRegistry.registerIcon("configdrift.actions", require("./rawicons/actions.icon.svg.js"));
IconRegistry.registerIcon("configdrift.activity", require("./rawicons/activity.icon.svg.js"));
IconRegistry.registerIcon("configdrift.add_device", require("./rawicons/add_device.icon.svg.js"));
IconRegistry.registerIcon("configdrift.cancelled", require("./rawicons/cancelled.icon.svg.js"));
IconRegistry.registerIcon("configdrift.changed", require("./rawicons/changed.icon.svg.js"));
IconRegistry.registerIcon("configdrift.compare", require("./rawicons/compare.icon.svg.js"));
IconRegistry.registerIcon(
    "configdrift.default_snapshot",
    require("./rawicons/default_snapshot.icon.svg.js")
);
IconRegistry.registerIcon(
    "configdrift.device_details",
    require("./rawicons/device_details.icon.svg.js")
);
IconRegistry.registerIcon("configdrift.device", require("./rawicons/device.icon.svg.js"));
IconRegistry.registerIcon("configdrift.devices", require("./rawicons/devices.icon.svg.js"));
IconRegistry.registerIcon("configdrift.iot_devices", require("./rawicons/iot_devices.icon.svg.js"));
IconRegistry.registerIcon(
    "configdrift.iot_devices_flat",
    require("./rawicons/iot_devices_flat.icon.svg.js")
);
IconRegistry.registerIcon(
    "configdrift.export_devices",
    require("./rawicons/export_devices.icon.svg.js")
);
IconRegistry.registerIcon(
    "configdrift.has_device_changed",
    require("./rawicons/has_device_changed.icon.svg.js")
);
IconRegistry.registerIcon(
    "configdrift.import_devices",
    require("./rawicons/import_devices.icon.svg.js")
);
IconRegistry.registerIcon("configdrift.queued", require("./rawicons/queued.icon.svg.js"));
IconRegistry.registerIcon("configdrift.report", require("./rawicons/report.icon.svg.js"));
IconRegistry.registerIcon("configdrift.roll_back", require("./rawicons/roll_back.icon.svg.js"));
IconRegistry.registerIcon("configdrift.same", require("./rawicons/same.icon.svg.js"));
IconRegistry.registerIcon("configdrift.snapshot", require("./rawicons/snapshot.icon.svg.js"));
IconRegistry.registerIcon("configdrift.snapshots", require("./rawicons/snapshots.icon.svg.js"));
IconRegistry.registerIcon("configdrift.system_note", require("./rawicons/system_note.icon.svg.js"));
IconRegistry.registerIcon("configdrift.views", require("./rawicons/views.icon.svg.js"));
IconRegistry.registerIcon(
    "configdrift.additional_options",
    require("./rawicons/additional_options.icon.svg.js")
);
IconRegistry.registerIcon("configdrift.back", require("./rawicons/back.icon.svg.js"));
IconRegistry.registerIcon("configdrift.started", require("./rawicons/startedSure.icon.svg"));
IconRegistry.registerIcon("configdrift.run_audit", require("./rawicons/run_audit.icon.svg.js"));
IconRegistry.registerIcon("configdrift.run_audit2", require("./rawicons/run_audit2.icon.svg.js"));
IconRegistry.registerIcon(
    "configdrift.audit_policy_explorer",
    require("./rawicons/audit_policy_explorer.icon.svg")
);
IconRegistry.registerIcon("configdrift.audit_policy", require("./rawicons/audit_policy.icon.svg"));
IconRegistry.registerIcon(
    "configdrift.audit_policy_history",
    require("./rawicons/audit_policy_history.icon.svg")
);
IconRegistry.registerIcon(
    "configdrift.audit_policy_details",
    require("./rawicons/audit_policy_details.icon.svg")
);
IconRegistry.registerIcon(
    "configdrift.audit_policy_download",
    require("./rawicons/audit_policy_download.icon.svg")
);
IconRegistry.registerIcon(
    "configdrift.audit_policy_passed",
    require("./rawicons/audit_policy_passed.icon.svg")
);
IconRegistry.registerIcon(
    "configdrift.audit_policy_failed",
    require("./rawicons/audit_policy_failed.icon.svg")
);

IconRegistry.registerIcon(
    "configdrift.audit_policy_skipped",
    require("./rawicons/audit_policy_skipped.icon.svg")
);
IconRegistry.registerIcon(
    "configdrift.add_audit_policy",
    require("./rawicons/add_audit_policy.icon.svg")
);

IconRegistry.registerIcon(
    "networkdiscovery.network_discovery",
    require("./rawicons/network_discovery.icon.svg.js")
);

IconRegistry.registerIcon(
    "networkdiscovery.network_discovery_flat",
    require("./rawicons/network_discovery_flat.icon.svg.js")
);

IconRegistry.registerIcon(
    "networkdiscovery.add_network_discovery",
    require("./rawicons/network_discovery_add.icon.svg.js")
);

IconRegistry.registerIcon(
    "networkdiscovery.run_network_discovery",
    require("./rawicons/network_discovery_run.icon.svg.js")
);

IconRegistry.registerIcon(
    "networkdiscovery.edit_network_discovery",
    require("./rawicons/network_discovery_edit.icon.svg.js")
);

IconRegistry.registerIcon("common.copy", require("./rawicons/copy.icon.svg.js"));

// Moved to ui-core
// IconRegistry.registerIcon(
//     "configdrift.compare_compact",
//     require("./rawicons/compare_compact_icon.svg")
// );
// IconRegistry.registerIcon(
//     "configdrift.compare_expanded",
//     require("./rawicons/compare_expanded_icon.svg")
// );
// IconRegistry.registerIcon(
//     "configdrift.compare_side_by_side",
//     require("./rawicons/compare_side_by_side_icon.svg")
// );
// IconRegistry.registerIcon(
//     "configdrift.compare_line_by_line",
//     require("./rawicons/compare_line_by_line_icon.svg")
// );
